import React, { useState } from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from "moment";

import "./SnpDateTimePicker.css";
import {
  isEmpty
} from "../../constants/constant";

export default function SnpDateTimePicker({ isLabel = false, format = "DD/MM/YYYY HH:mm:ss", dateTimeStr, setDateTimeStr }) {

    const parsedDateTime = isEmpty(dateTimeStr) ? moment() : moment(dateTimeStr, format);

    const [dateTime, setDateTime] = useState(parsedDateTime);


    return (
        <div className="datetime-container">
            {isLabel && <label className="datetime-label">📅 Select Date & Time</label>}
            <Datetime
                value={dateTime}
                onChange={(val) => {
                    if (moment.isMoment(val) && val.isValid()) {
                        setDateTime(val);
                        setDateTimeStr(val.format(format));
                    } else {
                        // User cleared or typed invalid input
                        setDateTime(val);
                        setDateTimeStr("");
                    }
                }}
                dateFormat="YYYY-MM-DD"
                timeFormat="HH:mm:ss"
                inputProps={{
                    placeholder: "Choose date & time...",
                    className: "datetime-input",
                }}
            />
        </div>
    );
}
